import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Grid, Row, Col } from 'react-bootstrap';
import Analytics from '../components/analytics/Analytics';
import { DATE_FORMAT, getCurrentTimeInCurrentTimezoneFormatted, getCurrentTimezone } from '../api/CallMeNow';
import { getCallMeNowSlots, setCallMeNowResponse } from '../actions/callMeNow';
import { setExperiencesList, setExperienceSelected } from '../actions/experiences';
import SHSbyAsurionTitleBar from '../components/shs/SHSbyAsurionTitleBar/SHSbyAsurionTitleBar';
import TopLevelNavBar from '../components/shs/TopLevelNavBar/TopLevelNavBar';
import ExperienceDetails from '../components/experiences/ExperienceDetails/ExperienceDetails';
import PopularExperiences from '../components/experiences/PopularExperiences/PopularExperiences';
import Footer from '../components/shs/Footer/Footer';
import ExperiencesDataListV2 from '../components/experiences/Data/ExperiencesV2';
import { getVhtSegment } from '../util/VhtUtil';
import { PartnerContext } from '../../../partner';

class ShsExperienceDetails extends Component {
  constructor(props) {
    super(props);
    this.reRender = this.reRender.bind(this);
    this.unListen = this.props.history.listen(this.reRender);
  }

  reRender() {
    window.scrollTo(0, 0);
    if (!this.props.experiencesList) {
      this.props.setExperiencesList(ExperiencesDataListV2);
    }
    const experiencesList =
      (this.props.experiencesList && this.props.experiencesList.data) || ExperiencesDataListV2.data;
    const queryData = queryString.parse(window.location.search);

    const selectedExperience = experiencesList.find((experience) => experience.megaUseCase === queryData.megaUseCase);
    if (selectedExperience) {
      selectedExperience.vhtSegment = getVhtSegment(selectedExperience.megaUseCase, this.props.context.productCode);
      this.props.setExperienceSelected(selectedExperience);
      if (!!selectedExperience.vhtSegment) {
        const requestTimeInCurrentTimezone = getCurrentTimeInCurrentTimezoneFormatted(DATE_FORMAT);
        this.props.setCallMeNowResponse({
          state: 'pending',
          errorCode: 0,
          vhtSlots: [],
          currentTimezone: '',
          waitInMinutes: -1,
          earliestSlot: null,
        });
        this.props.getCallMeNowSlots(selectedExperience.vhtSegment, 'null', requestTimeInCurrentTimezone);
      }
    }
  }

  componentDidMount() {
    this.reRender();
  }
  componentWillUnmount() {
    if (this.unListen) this.unListen();
  }
  render() {
    return (
      <div className="ShsExperienceDetailsContainer">
        <ExperienceDetails />
        <PopularExperiences />
      </div>
    );
  }
}

const ShsExperienceDetailsWrapper = (props) => (
  <PartnerContext.Consumer>
    {(context) => <ShsExperienceDetails context={context[0]} {...props} />}
  </PartnerContext.Consumer>
);

const mapStateToProps = (state /*, ownProps*/) => ({
  callMeNowResponse: state.callMeNow.callMeNowResponse,
  maxCustomerWaitTime: state.callMeNow.maxCustomerWaitTime,
  vhtSegment: state.experiences.experienceSelected && state.experiences.experienceSelected.vhtSegment,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCallMeNowSlots,
      setCallMeNowResponse,
      setExperiencesList,
      setExperienceSelected,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShsExperienceDetailsWrapper));



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/pages/ShsExperienceDetails.js